import React from 'react';
import {
  NewYorkCityFC, 
  LAGalaxy, 
  ColumbusCrew,
  LosAngelesFC,
  SeattleSoundersFC,
  AtlantaUnitedFC,
  TorontoFC,
  PortlandTimbers,
  SportingKansasCity,
  ColoradoRapids,
  RealSaltLake,
  HoustonDynamoFC,
  DCUnited,
  SanJoseEarthquakes,
  ChicagoFireFC,
  InterMiamiCF
} from "../clubs";

const Mls = () => {
  return (
     <div>
    <h1>Dates of the last league titles for each club that has won Major League Soccer (MLS).</h1>
    <InterMiamiCF />
    <LAGalaxy /> 
    <ColumbusCrew />
    <LosAngelesFC />
    <NewYorkCityFC />
    <SeattleSoundersFC />
    <AtlantaUnitedFC />
    <TorontoFC />
    <PortlandTimbers />
    <SportingKansasCity />
    <ColoradoRapids />
    <RealSaltLake />
    <HoustonDynamoFC />
    <DCUnited />
    <SanJoseEarthquakes/>
    <ChicagoFireFC />
    </div>
  )
}

export default Mls;